module.exports = __webpack_public_path__ + "static/CORPORATE_SITE__HEADER_MB_WHOWEARE-4b8926dc7f304c294f3cc239b170f181.jpg";